export default __webpack_public_path__ + "static/media/V5.697295ef.mp4";